import { Loader } from "../loader";
import { DataTable } from "../data_table";
import { Pagination } from "../pagination";
import { AddButton, Search } from "../buttons";
import { Link } from "react-router-dom";
import i18next from "i18next";

const ListLayout = ({
    showHeader = false,
    title,
    loading,
    rowData,
    columnDefs,
    tableLoading,
    // optional
    showAdd = false,
    onAdd,
    addLink,
    addPermission = false,
    showSearch = false,
    onFilter,
    showPagination = false,
    pageable,
    total_count,
    total_amount,
    headerLink,
    height,
}) => {
    return (
        <div className="container-fluid">
            <div className="row">
                {/* Header */}
                {showHeader &&
                    <div className="col-md-12">
                        <div className="layout d-flex justify-content-between align-items-center">
                            <h6>{title}</h6>
                            <div className="d-flex align-items-center">
                                {showAdd && addPermission && (
                                    addLink ? (
                                        <Link to={addLink}>
                                            <AddButton button_name={i18next.t("common.add")} />
                                        </Link>
                                    ) : (
                                        <AddButton
                                            button_name={i18next.t("common.add")}
                                            onClick={onAdd}
                                        />
                                    )
                                )}
                                <div className="d-flex align-items-center">
                                   <div>
                                     {total_count ? <h6 className="me-3 text-bold text-end">{total_count} : {pageable?.totalRecord}</h6> : ''}
                                     {total_amount ? <h6 className="me-3 text-bold text-end mt-1">{total_amount}</h6>:''}
                                   </div>
                                    {showSearch && (
                                        <Search
                                            onClick={onFilter}
                                            tooltip_content={i18next.t('common.filter')}
                                        />
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                }

                {/* Loader or Content */}
                {loading ? (
                    <div className="col-md-12">
                        <div className="layout">
                            <Loader />
                        </div>
                    </div>
                ) : (
                    <>
                        {/* Data Table */}
                        <div className="col-md-12">
                            <DataTable
                                rowData={rowData}
                                columnDefs={columnDefs}
                                loading={tableLoading}
                                height={height}
                            />
                        </div>

                        {/* Pagination (optional) */}
                        {showPagination && (
                            <div className="col-md-12">
                                <Pagination
                                    per_page_disabled={loading}
                                    per_page_default_value={pageable?.pageSize}
                                    per_page_onChange={(e) => pageable.perPage(e)}
                                    left_disabled={loading || !headerLink?.hasOwnProperty("prev")}
                                    left_onClick={() => pageable.goToPage(headerLink?.prev?.page)}
                                    currentPage={pageable?.currentPage}
                                    pageSize={pageable?.pageSize}
                                    totalRecord={pageable?.totalRecord}
                                    right_disabled={
                                        loading || !headerLink?.hasOwnProperty("next")
                                    }
                                    right_onClick={() =>
                                        pageable.goToPage(headerLink?.next?.page)
                                    }
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ListLayout;